<script setup lang="ts">
import CheckoutNotification from "#core/features/notifications/components/CheckoutNotification.vue";
import { onClickOutside } from '@vueuse/core';
import {useNotificationsStore} from "#core/features/notifications/stores/notificationsStore";

const props = defineProps({
  hideIfEmpty: {
    type: Boolean,
    default: false,
  },
})

const notificationsElement = ref();
const isVisible = ref(false);

onClickOutside(notificationsElement, (event) => {
  isVisible.value = false;
});

const notificationsStore = useNotificationsStore();

const {notifications, count} = storeToRefs(notificationsStore);
const {clearAll, read} = notificationsStore;

const iconName = computed(() => count.value > 0 ? 'clarity:bell-solid' : 'clarity:bell-line');

const onRemoved = (id: string) => {
  read(id);
  isVisible.value = false;
}
</script>

<template>
  <div class="relative z-50" v-show="!hideIfEmpty || (hideIfEmpty && count > 0)">
    <div @click="isVisible = true" class="relative">
      <Icon :name="iconName"
            size="24"
            class="cursor-pointer hover:text-meclee-blue-200"
      />
      <div v-if="count > 0"
           class="absolute -top-2 -right-2 bg-rose-400 text-white font-medium text-center rounded-full text-xs h-4 w-4"
      >
        {{ count }}
      </div>
    </div>

    <div v-show="isVisible"
         class="fixed md:absolute bg-white shadow rounded-lg p-4 right-10 md:-right-2 mt-4 border border-meclee-blue-200 w-[300px]"
         :class="{'md:w-[300px]': count === 0, 'md:w-[500px]': count > 0}"
         ref="notificationsElement"
    >
      <p class="font-semibold">{{ $t('notificationsStatusBar.title') }}</p>

      <div v-if="count === 0">
        {{ $t('notificationsStatusBar.notFound') }}
      </div>
      <div v-else class="h-48 overflow-y-auto">
        <template :key="`notification-${id}`" v-for="(notification, id) in notifications">
          <CheckoutNotification
            v-if="notification.type === 'checkout'"
            :psychologist="notification.data.psychologist"
            @remove="onRemoved(id)"
          />
        </template>
      </div>
    </div>
<!--    <Icon name="clarity:bell-solid" />-->
  </div>
</template>

<style scoped>

</style>